import { render, staticRenderFns } from "./SkuSetting.vue?vue&type=template&id=232b2923&scoped=true"
import script from "./SkuSetting.vue?vue&type=script&lang=js"
export * from "./SkuSetting.vue?vue&type=script&lang=js"
import style0 from "./SkuSetting.vue?vue&type=style&index=0&id=232b2923&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b2923",
  null
  
)

export default component.exports